module.exports = __webpack_public_path__ + "static/studio_06-0961e6372455e08c43ee5c36694caaf4.jpg";